import React, { memo } from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from 'react-daisyui';
import { PORTAL_ROUTES } from 'utils/constants';
import { Link } from 'react-router-dom';
import { formatDate } from 'utils/helpers';
import { roleAbbreviations, txpStatusBadgeColors, patientDecision } from './helper';
import StatusBadge from 'components/StatusBadge';
import { startCase } from 'lodash'

const TreatmentPlanItem = ({ data, amount = null }) => {
  let { title, amount_to_pay, provider, created_at, state, patient_decision_at, patient_decision_type, encoded_id } = data?.attributes || {};
  let { first_name, last_name, role } = provider?.data?.attributes || {};

  let _amount = amount || amount_to_pay;

  return (
    <Link to={`${PORTAL_ROUTES.TREATMENT_PLANS}/${encoded_id}`}
      className={`card border shadow-sm block bg-base-100 border-base-200 hover:shadow-md transition-shadow`}
    >
      <div className="card-body p-5 space-y-3">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-semibold text-secondary-900 text-sm leading-snug">{title}</h3>
          <span className="text-base font-bold text-blue-500 whitespace-nowrap shrink-0">
            ${_amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}
          </span>
        </div>

        <div className="flex flex-col gap-1">
          <p className="text-xs text-secondary-400">
            <span className="font-medium text-secondary-600">Provider: </span>
            {roleAbbreviations[role]} {first_name} {last_name}
          </p>
          <p className="text-xs text-secondary-400">
            <span className="font-medium text-secondary-600">Date:</span> {formatDate(created_at, "short")}
          </p>
        </div>

        <div className="flex items-center justify-between pt-2 border-t border-base-200">
          <StatusBadge
            status={startCase(state)}
            className={txpStatusBadgeColors[state]}
          />

          {patient_decision_type &&
            <div className="text-right">
              <p className="text-xs text-secondary-400 mb-1">Patient Decision</p>
              <StatusBadge
                status={(!patient_decision_at && patient_decision_type == 'scheduled') ? 'Scheduled' : patientDecision[patient_decision_type].state}
                className={patientDecision[patient_decision_type].className}
              />
            </div>
          }
        </div>

        <div className='pt-3 flex justify-end'>
          <Button
            size="xs" color="ghost"
            className="text-blue-500 hover:text-blue-500 hover:bg-transparent px-0 gap-1 min-h-0 h-auto w-fit self-end absolute bottom-5"
          >
            View Details <ChevronRight size={13} />
          </Button>
        </div>
      </div>
    </Link>
  );
}

export default memo(TreatmentPlanItem);
